export default __webpack_public_path__ + "static/media/union-green.9018f849.svg";